import React from "react";
import { PanelEditShop } from "../../UI/ShopAds/edit/PanelEditShop";

const ShopAdsEdit = () => {
  return (
    <div>
      <PanelEditShop />
    </div>
  );
};

export default React.memo(ShopAdsEdit);
